var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcpDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    fillRule: "evenodd",
    d: "M20.32 7.029h.1l-.061-.05 3.81-3.81.008-.068A12.388 12.388 0 0 0 4.025 9.143a1.554 1.554 0 0 1 .2-.067 8.888 8.888 0 0 1 6.625-1.311.115.115 0 0 1 .081-.021 6.872 6.872 0 0 1 9.409-.715h-.02",
    transform: "translate(15.801 19)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    fillRule: "evenodd",
    d: "M28.595 9.306a12.447 12.447 0 0 0-3.742-6.033l-3.869 3.868a6.878 6.878 0 0 1 2.524 5.459v.685c4.589 0 4.589 6.885 0 6.885h-6.886l-.01.011v5.464h-.029l.04.04h6.886a8.957 8.957 0 0 0 5.086-16.379",
    transform: "translate(15.176 18.837)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    fillRule: "evenodd",
    d: "M9.086 26.507h6.884V21H9.086a3.379 3.379 0 0 1-1.414-.31l-3.981 3.98-.01.042a8.916 8.916 0 0 0 5.406 1.8",
    transform: "translate(15.816 17.972)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    fillRule: "evenodd",
    d: "M8.9 8a8.954 8.954 0 0 0-5.4 16.047l4-3.993a3.442 3.442 0 1 1 4.546-4.554l3.994-3.992A8.947 8.947 0 0 0 8.9 8",
    transform: "translate(16 18.603)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpDefault);
export default __webpack_public_path__ + "static/media/gcp-default.319a8a1b8eb24201891f97d0f6716716.svg";
export { ForwardRef as ReactComponent };